// src/App.js
//
// Two routes: the catalogue at / and a unit at /:slug. The portal already
// links enquiries to requip.brookerefrigeration.com/<slug>, so that shape is
// fixed.

import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { ContentProvider } from "./ContentContext";
import { BackToTop, Footer, Header, MobileBar } from "./components/Chrome";
import Catalogue from "./pages/Catalogue";
import Item from "./pages/Item";

// New page starts at the top. A hash scrolls to its target once it exists,
// since the stock grid renders after its fetch rather than on first paint.
function ScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }
    let tries = 0;
    const t = setInterval(() => {
      const el = document.getElementById(hash.slice(1));
      if (el || ++tries > 20) {
        clearInterval(t);
        el?.scrollIntoView({ behavior: "smooth" });
      }
    }, 80);
    return () => clearInterval(t);
  }, [pathname, hash]);

  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ContentProvider>
        <ScrollManager />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Catalogue />} />
            <Route path="/:slug" element={<Item />} />
          </Routes>
        </main>
        <Footer />
        <BackToTop />
        <MobileBar />
      </ContentProvider>
    </BrowserRouter>
  );
}
